export const environment = {
  production: false,
  ENABLE_DEBUG: false,
  RESERVE_URL: 'https://bff-hml-tablereservation.grupomadero.com.br',
  CRYPTO_AES_KEY: '4So+kfod/O+SJ1Gika2X6osyntrKNAL1//sFS0U2Tlk=',
  CRYPTO_AES_IV: '3AB5lsqxDsfUBImCf3pN3w==',
  WAITING_LIST_POLLING_INTERVAL_MS: 10000,
};
